module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-02.a02bfd4b.svg";